import { ACCOUNT_TYPE_LABELS, CUG_TIER_LABELS, CUG_TIER_OPTIONS } from '~/components/GHAPropertyManagement/constants';

// Single source for GHA tier/account labels is GHAPropertyManagement's constants (derived from
// the generated client types). Re-exported here widened to string keys because this component's
// service types are provisional hand-written interfaces until the GHA-442 endpoint is deployed
// and models.d.ts regenerated.
export const TIER_LABELS: Record<string, string> = CUG_TIER_LABELS;

export const TIER_ORDER: Array<string> = CUG_TIER_OPTIONS;

export const ACCOUNT_LABELS: Record<string, string> = ACCOUNT_TYPE_LABELS;
